import React, { FC } from "react";
import {
  makeStyles,
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@material-ui/core";
import { ExternalChatMessage } from "domain-entities";
import { color, px } from "Configs/theme";
import GalleryImage from "./GalleryImage";
import CloseIcon from "@material-ui/icons/Close";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { getColorRgbaFromHex } from "Helpers/ColorHelper";
import { useDownloadMessageMedia } from "Components/Message/MessageHelper";

interface Props {
  message?: ExternalChatMessage;
  close: () => void;
}

const GalleryModal: FC<Props> = (props) => {
  const classes = useStyles();
  const downloadMessageMedia = useDownloadMessageMedia();

  return (
    <Dialog
      open={!!props.message}
      onClose={props.close}
      classes={{ paper: classes.dialogPaper }}
      fullScreen
      disablePortal
    >
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.safeArea}>
          <Box className={classes.header}>
            <IconButton className={classes.closeButton} onClick={props.close}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
            <IconButton
              className={classes.closeButton}
              onClick={() => downloadMessageMedia(props.message)}
            >
              <CloudDownloadIcon className={classes.closeIcon} />
            </IconButton>
          </Box>
          {props.message && <GalleryImage message={props.message} />}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GalleryModal;

const useStyles = makeStyles({
  dialogPaper: {
    backgroundColor: getColorRgbaFromHex(color.galleryBackground, 0.5),
  },
  dialogContent: {
    padding: 0,
    paddingTop: "0 !important",
    display: "flex",
  },
  safeArea: {
    display: "flex",
    position: "relative",
    flex: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    padding: `0 ${px.m}`,
    top: 0,
    left: 0,
    right: 0,
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%)",
  },
  closeButton: {},
  closeIcon: {
    color: color.card,
  },
});
